// Localização: frontend/src/components/Prontuario/ProfissionalProntuarioTabs.jsx (versão 1.0.0)
// Componente de abas para o prontuário do profissional

import React, { useState } from 'react';
import { User, Briefcase, FileText, DollarSign, CalendarX, Calendar, Clock, Award, Link2 } from 'lucide-react';
import ProfissionalDadosPessoaisTab from './Profissional/ProfissionalDadosPessoaisTab';
import ProfissionalRHTab from './Profissional/ProfissionalRHTab';
import ProfissionalDocumentosTab from './Profissional/ProfissionalDocumentosTab';
import ProfissionalVinculosPacientesTab from './Profissional/ProfissionalVinculosPacientesTab';

const TABS = [
    {
        id: 'dados-pessoais',
        name: 'Dados Pessoais',
        icon: User,
        component: ProfissionalDadosPessoaisTab
    },
    {
        id: 'rh',
        name: 'Recursos Humanos',
        icon: Briefcase,
        component: ProfissionalRHTab
    },
    {
        id: 'documentos',
        name: 'Documentos',
        icon: FileText,
        component: ProfissionalDocumentosTab
    },
    {
        id: 'vinculos-pacientes',
        name: 'Vínculo com Pacientes',
        icon: Link2,
        component: ProfissionalVinculosPacientesTab
    }
];

const ProfissionalProntuarioTabs = ({ profissionalId, prontuarioData, onRefresh }) => {
    const [activeTab, setActiveTab] = useState('dados-pessoais');

    const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component || ProfissionalDadosPessoaisTab;

    return (
        <div className="w-full">
            {/* Navegação de Abas */}
            <div className="border-b border-gray-200 mb-4">
                <nav className="-mb-px flex space-x-4 overflow-x-auto" aria-label="Tabs">
                    {TABS.map((tab) => {
                        const Icon = tab.icon;
                        const isActive = activeTab === tab.id;
                        return (
                            <button
                                key={tab.id}
                                onClick={() => setActiveTab(tab.id)}
                                className={`
                                    flex items-center space-x-2 py-4 px-1 border-b-2 font-medium text-sm whitespace-nowrap
                                    transition-colors duration-200
                                    ${isActive
                                        ? 'border-teal-500 text-teal-600'
                                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                    }
                                `}
                            >
                                <Icon className="h-5 w-5" />
                                <span>{tab.name}</span>
                            </button>
                        );
                    })}
                </nav>
            </div>

            {/* Conteúdo da Aba Ativa */}
            <div className="mt-4">
                <ActiveComponent
                    profissionalId={profissionalId}
                    prontuarioData={prontuarioData}
                    onRefresh={onRefresh}
                />
            </div>
        </div>
    );
};

export default ProfissionalProntuarioTabs;

